// Installed integration configuration. Saved declarations cannot install code
// or alter this reviewed mapper's immutable identity and exact input contract.
export const TRUSTED_REFRESH_MAPPER = Object.freeze({
  id: 'villoid-products',
  version: '1',
  digest: '1a7ed850cfbdf730471a2350b03012164b13b37e54366b64415046102bc1174f',
});
export const TRUSTED_REFRESH = Object.freeze({
  mapper: TRUSTED_REFRESH_MAPPER,
  toolRef: 'villoid__search_products',
  arguments: Object.freeze({ query: 'jeans', limit: 8 }),
  collectionId: 'villoid_observations',
  collectionName: 'VilloidObservations',
  fields: Object.freeze([
    Object.freeze({ id: 'query', name: 'query', type: 'text', required: true, nullable: false }),
    Object.freeze({
      id: 'snapshot',
      name: 'snapshot',
      type: 'json',
      required: true,
      nullable: false,
    }),
  ]),
  jobId: 'villoid_trusted_refresh',
  jobName: 'VilloidTrustedRefresh',
});
export const TRUSTED_REFRESH_DEFINITIONS = Object.freeze([TRUSTED_REFRESH]);
